<button (click)="click()">
  @if (!activated) {
    <app-ng-icon class="text-3xl text-fg-muted" name="heroStar"></app-ng-icon>
  }
  @if (activated) {
    <app-ng-icon class="text-3xl text-primary" name="heroStarSolid"></app-ng-icon>
  }
</button>
